import { Alert, List } from 'antd';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { HttpStatusCode } from 'axios';
import { useNotificationStore } from './notification_store';
import { ApiError } from '../../../api/api';
import { NotificationListReponse, NotificationReponse } from '../../../model/notification_response';
import styles from './index.module.scss';
import {
  BusinessTypeKeys,
  BusinessTypes, DataTypeKeys,
  getEnumByKey,
  IssueType,
  Priority,
  ProcessingStatusDisplay,
} from '../../../constant';
import { DateFormat } from '../../../utils/date_utils';
import { Messages } from '../../../constant/messages';
import { useIndicator } from '../../../hook/use_indicator';

/**
 * 通知一覧画面
 * @constructor
 */
export const NotificationView : React.FC = () => {
  const navigator = useNavigate();
  const { getNotification } = useNotificationStore((selector) => selector);
  const [data, setData] = useState<NotificationListReponse>();
  const indicator = useIndicator();

  const MESSAGE_INS = '【臨時作業が登録されました】';
  const MESSAGE_UPD = '【臨時作業が更新されました】';

  useEffect(() => {
    indicator.show();
    // 通知一覧取得
    getNotification().then((res) => {
      setData(res);
    }).catch((e) => {
      if (e instanceof ApiError) {
        const { status } = e.response;
        if (status === HttpStatusCode.Unauthorized || status === HttpStatusCode.Forbidden) {
          window.alert(Messages.ERR_DIALOG_RETURN_LOGIN);
          navigator('/login', { state: { message: Messages.ERR_401 } });
        } else if (status === -1) {
          window.alert(Messages.ERR_DIALOG_TIMEOUT);
        } else {
          window.alert(Messages.ERR_DIALOG_RETRY_OPERATION);
        }
      }
    }).finally(() => {
      indicator.hide();
    });
  }, []);

  const onItemClick = (item:NotificationReponse) => {
    navigator(`/issue/${item.workId}/details/${item.planId}`);
  };
  return (
    <div>
      <h1>通知一覧画面</h1>
      <div className={styles.section}>

          <List
            itemLayout="horizontal"
            dataSource={data}
            renderItem={(item, index) => (
              <div className={styles.item} onClick={() => {
                onItemClick(item);
              }}>
                <List.Item className={styles.item}>
                  <List.Item.Meta
                    title={
                      <div className={styles.title}>
                        <div className={styles.content}>
                          <div className={styles.nestContent}>
                              <div className={styles.msg}>
                                {(item.issueType === IssueType.NEW) ? MESSAGE_INS : MESSAGE_UPD}
                              </div>
                              <div className={styles.statusArea}>
                                <div className={styles.text + ' ' + styles.status}>
                                  {ProcessingStatusDisplay.find((status) => status.key === item.status)?.value ?? '未対応'}
                                </div>
                                <div className={styles.text + ' ' + styles.priority}>
                                  優先度：{Priority.find((priprity) => priprity.key === item.priority)?.value || '-'}
                                </div>
                              </div>
                            </div>
                            <div className={styles.nestContent}>
                              <div className={styles.type}>
                                {BusinessTypes.find((type) => type.key === item.businessType)?.value ?? '不明'}
                              </div>
                              <div className={styles.companyName}>
                                {item.companyName}
                              </div>
                              <div className={styles.incidentName}>
                                {item.incidentName}
                              </div>
                            </div>
                          </div>
                        </div>
                        }
                        description={
                        <div className={styles.description}>
                        <div className={styles.issueDateTime}>
                          {dayjs(item.issueDateTime)
                            .format(DateFormat.YYYYMMDDHHMMSS)}
                        </div>
                        <div className={styles.area}>
                          <span>{item.division}</span>
                          <span>{item.floor}</span>
                          <span>{item.block}</span>
                        </div>
                      </div>
                    }
                  />
                </List.Item>
              </div>
            )}
          />
      </div>
    </div>
  );
};
